import { render, staticRenderFns } from "./appItem.vue?vue&type=template&id=d1ba137e&scoped=true&"
import script from "./appItem.vue?vue&type=script&lang=js&"
export * from "./appItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ba137e",
  null
  
)

export default component.exports